const Integrations = {
  UseBillogram: "Integrations.UseBillogram",
  UseBillogramDescription: "Integrations.UseBillogramDescription",
  UserName: "Integrations.UserName",
  BillogramAccountDimensions: "Integrations.BillogramAccountDimensions",
  BillogramAccountDimensionsDescription: "Integrations.BillogramAccountDimensionsDescription",
  EnableQbisConnection: "Integrations.EnableQbisConnection",
  QbisLoginDetails: "Integrations.QbisLoginDetails",
  QbisLoginDetailsDescription: "Integrations.QbisLoginDetailsDescription",
  ApiKey: "Integrations.ApiKey",
  EnableJobbileConnection: "Integrations.EnableJobbileConnection",
  ActivateYourIntegration: "Integrations.ActivateYourIntegration",
  NotConnected: "Integrations.NotConnected",
  UseStripeConnect: "Integrations.UseStripeConnect",
  UseStripeConnectDescription: "Integrations.UseStripeConnectDescription",
  StripeStatusUnavailable: "Integrations.StripeStatusUnavailable",
  StripeStatusUnavailableDescription: "Integrations.StripeStatusUnavailableDescription",
  StripeConnectSuccess: "Integrations.StripeConnectSuccess",
  VismaAdvisorLogin: "Integrations.VismaAdvisorLogin",
  VismaAdvisorLoginDescription: "Integrations.VismaAdvisorLoginDescription",
  VismaAdvisorIsRightAgency: "Integrations.VismaAdvisorIsRightAgency",
  VismaAdvisorConfirmDescription: "Integrations.VismaAdvisorConfirmDescription",
  VismaAdvisorReauthorizeDescription: "Integrations.VismaAdvisorReauthorizeDescription",
  VismaAdvisorConnectedDescription: "Integrations.VismaAdvisorConnectedDescription",
  VismaAdvisorPausedDescription: "Integrations.VismaAdvisorPausedDescription",
  VismaAdvisorConfirmAgency: "Integrations.VismaAdvisorConfirmAgency",
  VismaAdvisorLoginAgain: "Integrations.VismaAdvisorLoginAgain",
  VismaAdvisorPaused: "Integrations.VismaAdvisorPaused",
  VismaAdvisorLoginSucceeded: "Integrations.VismaAdvisorLoginSucceeded",
  VismaAdvisorConfirmed: "Integrations.VismaAdvisorConfirmed",
  VismaAdvisorDiscarded: "Integrations.VismaAdvisorDiscarded",
  VismaAdvisorLoginFailed: "Integrations.VismaAdvisorLoginFailed",
  VismaAdvisorLoginCancelled: "Integrations.VismaAdvisorLoginCancelled",
  VismaAdvisorWrongAgency: "Integrations.VismaAdvisorWrongAgency",
  VismaAdvisorAgencyAlreadyConnected: "Integrations.VismaAdvisorAgencyAlreadyConnected",
  VismaAdvisorLoginExpired: "Integrations.VismaAdvisorLoginExpired",
  }
export default Integrations;